import {
  SmartTable,
  SmartTableColumn,
  SmartTableDataItem,
} from '@toggle/design-system';
import React from 'react';

import * as S from './SharedTable.styles';

export interface SharedTableProps<T> {
  tableData: SmartTableDataItem<T>[];
  tableColumns: SmartTableColumn<T>[];
  onRowClick?: (item: SmartTableDataItem<T>) => void;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  onRowClick,
}: SharedTableProps<T>) => {
  return (
    <S.Root>
      <SmartTable
        columns={tableColumns}
        data={tableData}
        onRowClick={onRowClick}
      />
    </S.Root>
  );
};
